/* eslint-disable react/no-danger */
import { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment/moment'
import { observer } from 'mobx-react/index'

import { withTranslation, Link } from '../../i18n'

import Button from '../Button'
import {
  Wrapper, Container, Content, PromoWrapper
} from './styles'

@observer
class PostPreview extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    post: PropTypes.instanceOf(Object).isRequired,
    promo: PropTypes.bool
  }

  static defaultProps = {
    promo: false
  }

  static getInitialProps() {
    return {
      namespacesRequired: ['magazine', 'common']
    }
  }

  render() {
    const { t, promo, post } = this.props
    const Wrap = promo ? PromoWrapper : Wrapper
    return (
      <Wrap className="promo" data-post-id={post.id}>
        <Link href={`/post?id=${post.id}#content`} as={`/mag/post/${post.id}/${post.slug}#content`} passHref>
          <Container>
            <div className="pictureWrapper">
              <div className="picture" style={{ backgroundImage: `url(${post.image_large})` }} />
            </div>
            <Content>
              <time dateTime={post.datetime}>
                {moment(post.datetime)
                  .format('DD.MM.YYYY')}
              </time>
              <h3>{post.name}</h3>
              <div className="postPreviewText" dangerouslySetInnerHTML={{ __html: post.short_description }} />
              <div className="actionButton">
                <Button notScale className="btn">{t('read-post')}</Button>
              </div>
            </Content>
          </Container>
        </Link>
      </Wrap>
    )
  }
}

export default withTranslation(['magazine', 'common'])(PostPreview)
